import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { FeedbackRepository } from '../shared-repositories';
import type { FeedbackService } from '../feedback-service';
import type { FeedbackData } from '../../types';

@injectable()
export class FeedbackServiceImpl implements FeedbackService {
    constructor(
        @inject(FeedbackRepository) private feedbackRepository: FeedbackRepository
    ) {
    }

    feedback<T>(data: FeedbackData<T>) {
        return this.feedbackRepository.feedback(data)
    }
}
